import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 16.2733H17.5V17.94H2.5V16.2733ZM10.8333 5.29703V14.6067H9.16667V5.29703L4.10744 10.3562L2.92893 9.17775L10 2.10667L17.0711 9.17775L15.8926 10.3562L10.8333 5.29703Z",
		fill: "white"
	})
});
export default SvgUpload;
